import { render } from "./VuetablePagination.vue?vue&type=template&id=4767d04c"
import script from "./VuetablePagination.vue?vue&type=script&lang=js"
export * from "./VuetablePagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__